import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CrudService } from 'src/app/@amiga-pyme/services/crud.service';

const baseRoute = '/operation/transfers';

@Injectable({
  providedIn: 'root'
})
export class TransferService extends CrudService {
  constructor(http: HttpClient) {
    super(http, baseRoute);
  }
}
